export const environment = {
  production: false,
  // GA4 web stream for this build; empty disables analytics
  ga4MeasurementId: 'G-QBES0VVK9Y',
  assetsURL: 'https://credique-us-assets.s3.us-west-2.amazonaws.com',
  memberPortalServiceURL: 'https://api.{{brandDomain}}',
  apiNodeUrl: 'https://d81skr9y46.execute-api.us-west-2.amazonaws.com/QA/api',
  maxSessionIdleTimeMinutes: 10,
  maxRegisterSessionTimeMinutes: 15,
  cipherPassphrase: '36ebe205bcdfc499a25e6923f4450fa8',
  googleMapsApi: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB0Nrp5Jb-3SM1SzTK_bvY60WUfPoQF7ls&libraries=places&language=en&callback=Function.prototype',
  maxAttemptsCreditCard: 4,
  maxAttemptsPerCreditCard: 2,
  urlRewardProgram: 'https://www.pfmverifyrewards.com/stream/datapost/?key=qV4pS6lU6gE0eK4xL2rD&method=get_token&customer_id=',
  anuraIntegration: 'https://script.anura.io/request.js?instance=504847813&source={source}&campaign={offerId}&additional={additional}',
  UrlRewardProgramIframe: "https://dev.mysavingsperks.com/login/login_by_stream/",
  // Boardwalk token is a vendor-issued client-side integration id (not a backend secret), following the same pattern as other third-party keys above
  BoardwalkIntegrationV2: "https://next.boardwalk.marketing/api/paths/{token}/serve",
  BoardwalkMyOffersToken: "DfaGVIn2kYTcUqWj9G03O0i34lnbESgp",
  UrlBucketDynamicCSSBoardwalk: "https://dynamic-css-boardwalk-page-us-credique.s3.us-west-2.amazonaws.com/dynamic-css-boardwalk-page-us-credique-{PageType}.css"
};
